webpackJsonp([62],{

/***/ 1235:
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";

// CONCATENATED MODULE: ./node_modules/babel-loader/lib!./node_modules/vue-loader/lib/selector.js?type=script&index=0!./src/components/LogoEnterpriseHqStack.vue
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//

/* harmony default export */ var LogoEnterpriseHqStack = ({
  name: 'LogoEnterpriseHqStack'
});
// CONCATENATED MODULE: ./node_modules/vue-loader/lib/template-compiler?{"id":"data-v-443483ea","hasScoped":false,"optionsId":"0","buble":{"transforms":{}}}!./node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/components/LogoEnterpriseHqStack.vue
var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('svg',{staticStyle:{"fill-rule":"evenodd","clip-rule":"evenodd","stroke-miterlimit":"5"},attrs:{"width":"100%","height":"100%","viewBox":"0 0 1125 397","version":"1.1","xmlns":"http://www.w3.org/2000/svg","xmlns:xlink":"http://www.w3.org/1999/xlink","xml:space":"preserve","xmlns:serif":"http://www.serif.com/"}},[_c('g',{attrs:{"id":"Artboard2","transform":"matrix(0.867462,0,0,0.517399,-147.513,74.0329)"}},[_c('rect',{staticStyle:{"fill":"none"},attrs:{"x":"170.052","y":"-143.087","width":"1296.89","height":"765.665"}}),_vm._v(" "),_c('clipPath',{attrs:{"id":"_clip1"}},[_c('rect',{attrs:{"x":"170.052","y":"-143.087","width":"1296.89","height":"765.665"}})]),_vm._v(" "),_c('g',{attrs:{"clip-path":"url(#_clip1)"}},[_c('g',{attrs:{"id":"Logo","transform":"matrix(0.596588,0,0,1.00023,-3229.73,-256.251)"}},[_c('g',{attrs:{"transform":"matrix(5.78669,0,0,5.78669,6348.92,687.429)"}},[_c('path',{staticStyle:{"fill":"rgb(0,113,206)","fill-rule":"nonzero"},attrs:{"d":"M0,-66.053L0,0L46.331,0L46.331,-10.569L11.606,-10.569L11.606,-66.053L0,-66.053Z"}})]),_vm._v(" "),_c('g',{attrs:{"transform":"matrix(5.78669,0,0,5.78669,6937.53,627.369)"}},[_c('path',{staticStyle:{"fill":"rgb(0,113,206)","fill-rule":"nonzero"},attrs:{"d":"M0,-45.295L0,-55.674L-48.974,-55.674L-48.974,10.379L0.472,10.379L0.472,-0.002L-37.367,-0.002L-37.367,-17.74L-4.247,-17.74L-4.247,-28.121L-37.367,-28.121L-37.367,-45.295L0,-45.295Z"}})]),_vm._v(" "),_c('g',{attrs:{"transform":"matrix(5.78669,0,0,5.78669,7521,816.412)"}},[_c('path',{staticStyle:{"fill":"rgb(0,113,206)","fill-rule":"nonzero"},attrs:{"d":"M0,-116.159L-47.968,-116.159C-49.547,-119.341 -52.82,-121.533 -56.612,-121.533C-61.943,-121.533 -66.267,-117.21 -66.267,-111.88C-66.267,-106.548 -61.943,-102.225 -56.612,-102.225C-52.82,-102.225 -49.547,-104.419 -47.968,-107.6L0,-107.6C28.787,-107.6 52.208,-84.18 52.208,-55.392C52.208,-26.605 28.787,-3.184 0,-3.184L-32.818,-3.184L-93.278,-88.341L-93.278,-22.29L-81.861,-22.29L-81.861,-55.665L-38.119,5.374L0,5.374C33.507,5.374 60.767,-21.886 60.767,-55.392C60.767,-88.899 33.507,-116.159 0,-116.159"}})]),_vm._v(" "),_c('g',{attrs:{"transform":"matrix(5.78669,0,0,5.78669,7103.16,265.887)"}},[_c('path',{staticStyle:{"fill":"rgb(0,113,206)","fill-rule":"nonzero"},attrs:{"d":"M0,86.581C-3.792,86.581 -7.064,88.773 -8.644,91.955L-181.899,91.955C-210.699,91.955 -234.129,68.919 -234.129,40.603C-234.129,12.288 -210.699,-10.748 -181.899,-10.748L-22.779,-10.748L36.6,72.847L36.6,6.796L25.182,6.796L25.182,39.085L-16.602,-19.307L-181.899,-19.307C-215.418,-19.307 -242.687,7.569 -242.687,40.603C-242.687,73.638 -215.418,100.514 -181.899,100.514L-8.644,100.514C-7.064,103.695 -3.792,105.888 0,105.888C5.331,105.888 9.653,101.565 9.653,96.234C9.653,90.903 5.331,86.581 0,86.581"}})]),_vm._v(" "),_c('g',{attrs:{"transform":"matrix(5.78669,0,0,5.78669,6261.36,628.293)"}},[_c('path',{staticStyle:{"fill":"rgb(0,113,206)","fill-rule":"nonzero"},attrs:{"d":"M0,-20.443L-14.993,-20.443C-15.115,-16.566 -15.671,-12.76 -16.655,-9.067C-15.271,-8.092 -14.361,-6.485 -14.361,-4.662C-14.361,-4.486 -14.372,-4.31 -14.388,-4.138C-11.904,-2.961 -9.492,-1.581 -7.173,0C-2.938,-5.781 -0.32,-12.818 0,-20.443"}})]),_vm._v(" "),_c('g',{attrs:{"transform":"matrix(5.78669,0,0,5.78669,6054.66,519.277)"}},[_c('path',{staticStyle:{"fill":"rgb(0,113,206)","fill-rule":"nonzero"},attrs:{"d":"M0,9.562C3.872,9.679 7.736,10.212 11.514,11.166C12.482,9.734 14.121,8.794 15.975,8.794C16.001,8.794 16.024,8.796 16.048,8.796C16.938,5.416 17.443,1.938 17.562,-1.604L13.951,-1.604C13.274,0.595 11.222,2.199 8.8,2.199C6.379,2.199 4.331,0.595 3.655,-1.604L0,-1.604L0,9.562Z"}})]),_vm._v(" "),_c('g',{attrs:{"transform":"matrix(5.78669,0,0,5.78669,6054.66,592.933)"}},[_c('path',{staticStyle:{"fill":"rgb(0,113,206)","fill-rule":"nonzero"},attrs:{"d":"M0,21.356L0.63,20.793C5.643,16.298 9.609,11.125 12.454,5.51C11.322,4.528 10.604,3.085 10.596,1.472C7.116,0.605 3.562,0.111 0,0L0,21.356Z"}})]),_vm._v(" "),_c('g',{attrs:{"transform":"matrix(5.78669,0,0,5.78669,6084.77,388.597)"}},[_c('path',{staticStyle:{"fill":"rgb(0,113,206)","fill-rule":"nonzero"},attrs:{"d":"M0,-17.314C5.109,-12.176 9.038,-6.316 11.671,0C13.521,-0.728 15.336,-1.571 17.109,-2.529C16.564,-4.429 17.101,-6.538 18.608,-7.945C13.517,-12.676 7.111,-16.003 0,-17.314"}})]),_vm._v(" "),_c('g',{attrs:{"transform":"matrix(5.78669,0,0,5.78669,6058.31,405.516)"}},[_c('path',{staticStyle:{"fill":"rgb(0,113,206)","fill-rule":"nonzero"},attrs:{"d":"M0,-20.232L-0.63,-20.796L-0.63,0.564C4.065,0.415 8.742,-0.392 13.258,-1.85C10.39,-8.666 5.92,-14.923 0,-20.232"}})]),_vm._v(" "),_c('g',{attrs:{"transform":"matrix(5.78669,0,0,5.78669,6054.66,411.917)"}},[_c('path',{staticStyle:{"fill":"rgb(0,113,206)","fill-rule":"nonzero"},attrs:{"d":"M0,13.785L3.655,13.785C4.332,11.582 6.379,9.982 8.8,9.982C11.222,9.982 13.272,11.582 13.949,13.785L17.562,13.785C17.406,9.051 16.553,4.422 15.026,0C10.143,1.596 5.079,2.471 0,2.622L0,13.785Z"}})]),_vm._v(" "),_c('g',{attrs:{"transform":"matrix(5.78669,0,0,5.78669,6208.35,691.912)"}},[_c('path',{staticStyle:{"fill":"rgb(0,113,206)","fill-rule":"nonzero"},attrs:{"d":"M0,-8.518C-2.076,-9.921 -4.232,-11.151 -6.449,-12.211C-7.437,-11.027 -8.923,-10.275 -10.584,-10.275C-10.792,-10.275 -11.003,-10.29 -11.204,-10.313C-13.749,-5.254 -17.149,-0.537 -21.355,3.693C-12.897,2.133 -5.434,-2.283 0,-8.518"}})]),_vm._v(" "),_c('g',{attrs:{"transform":"matrix(5.78669,0,0,5.78669,6032.71,596.194)"}},[_c('path',{staticStyle:{"fill":"rgb(0,113,206)","fill-rule":"nonzero"},attrs:{"d":"M0,20.229L0.63,20.793L0.63,-0.564C-4.063,-0.417 -8.74,0.391 -13.258,1.849C-10.391,8.664 -5.924,14.92 0,20.229"}})]),_vm._v(" "),_c('g',{attrs:{"transform":"matrix(5.78669,0,0,5.78669,6231.44,490.111)"}},[_c('path',{staticStyle:{"fill":"rgb(0,113,206)","fill-rule":"nonzero"},attrs:{"d":"M0,-17.14C-2.006,-15.747 -4.667,-15.894 -6.499,-17.412C-8.466,-16.337 -10.486,-15.398 -12.543,-14.587C-10.898,-9.826 -9.981,-4.836 -9.822,0.272L5.171,0.272C4.902,-6.065 3.051,-11.997 0,-17.14"}})]),_vm._v(" "),_c('g',{attrs:{"transform":"matrix(-5.78669,0,0,5.78669,5934.71,589.777)"}},[_c('path',{staticStyle:{"fill":"rgb(0,113,206)","fill-rule":"nonzero"},attrs:{"d":"M-17.565,-13.787L0,-13.787C-0.16,-9.051 -1.015,-4.423 -2.536,0C-7.421,-1.595 -12.483,-2.47 -17.565,-2.621L-17.565,-13.787Z"}})]),_vm._v(" "),_c('g',{attrs:{"transform":"matrix(5.78669,0,0,5.78669,6036.36,408.778)"}},[_c('path',{staticStyle:{"fill":"rgb(0,113,206)","fill-rule":"nonzero"},attrs:{"d":"M0,-21.36L-0.63,-20.796C-5.645,-16.3 -9.611,-11.126 -12.457,-5.51C-11.325,-4.528 -10.605,-3.087 -10.599,-1.471C-7.116,-0.604 -3.563,-0.112 0,0L0,-21.36Z"}})]),_vm._v(" "),_c('g',{attrs:{"transform":"matrix(5.78669,0,0,5.78669,6036.36,482.421)"}},[_c('path',{staticStyle:{"fill":"rgb(0,113,206)","fill-rule":"nonzero"},attrs:{"d":"M0,-9.562C-3.875,-9.676 -7.733,-10.209 -11.517,-11.163C-12.486,-9.733 -14.122,-8.791 -15.98,-8.791C-16.004,-8.791 -16.024,-8.795 -16.051,-8.795C-16.936,-5.415 -17.447,-1.938 -17.565,1.601L0,1.601L0,-9.562Z"}})]),_vm._v(" "),_c('g',{attrs:{"transform":"matrix(5.78669,0,0,5.78669,5829.66,373.401)"}},[_c('path',{staticStyle:{"fill":"rgb(0,113,206)","fill-rule":"nonzero"},attrs:{"d":"M0,20.441L14.992,20.441C15.113,16.567 15.669,12.761 16.651,9.07C15.265,8.097 14.355,6.489 14.355,4.666C14.355,4.488 14.366,4.313 14.384,4.14C11.904,2.962 9.492,1.582 7.172,0C2.935,5.78 0.321,12.816 0,20.441"}})]),_vm._v(" "),_c('g',{attrs:{"transform":"matrix(5.78669,0,0,5.78669,5943.88,299.601)"}},[_c('path',{staticStyle:{"fill":"rgb(0,113,206)","fill-rule":"nonzero"},attrs:{"d":"M0,12.037C0.214,12.037 0.418,12.052 0.625,12.076C3.169,7.015 6.57,2.296 10.776,-1.935C2.319,-0.375 -5.146,4.042 -10.585,10.278C-8.504,11.68 -6.348,12.911 -4.13,13.972C-3.145,12.79 -1.66,12.037 0,12.037"}})]),_vm._v(" "),_c('g',{attrs:{"transform":"matrix(5.78669,0,0,5.78669,6006.24,613.096)"}},[_c('path',{staticStyle:{"fill":"rgb(0,113,206)","fill-rule":"nonzero"},attrs:{"d":"M0,17.313C-5.108,12.175 -9.034,6.316 -11.669,0C-13.518,0.729 -15.337,1.572 -17.109,2.528C-16.563,4.429 -17.1,6.537 -18.605,7.945C-13.517,12.675 -7.109,16.001 0,17.313"}})]),_vm._v(" "),_c('g',{attrs:{"transform":"matrix(5.78669,0,0,5.78669,5859.57,511.57)"}},[_c('path',{staticStyle:{"fill":"rgb(0,113,206)","fill-rule":"nonzero"},attrs:{"d":"M0,17.142C2.006,15.748 4.666,15.896 6.498,17.414C8.466,16.339 10.485,15.4 12.545,14.589C10.899,9.827 9.982,4.837 9.822,-0.272L-5.17,-0.272C-4.905,6.066 -3.05,11.998 0,17.142"}})]),_vm._v(" "),_c('g',{attrs:{"transform":"matrix(5.78669,0,0,5.78669,7494.78,633.369)"}},[_c('path',{staticStyle:{"fill":"rgb(0,113,206)","fill-rule":"nonzero"},attrs:{"d":"M0,-47.369C6.039,-47.369 11.984,-45.01 17.929,-40.575C19.459,-39.473 20.856,-38.328 22.127,-37.14L22.127,-50.82C19.099,-52.767 10.452,-57.654 0.189,-57.654C-12.927,-57.654 -22.363,-49.822 -22.363,-38.5L-22.363,-38.31C-22.363,-26.139 -14.437,-21.986 -0.377,-18.59C11.89,-15.758 14.532,-13.211 14.532,-8.492L14.532,-8.305C14.532,-3.397 10.003,0 2.831,0C-5.283,0 -11.7,-3.114 -18.022,-8.588C-19.481,-9.859 -20.806,-11.162 -22.009,-12.502L-22.009,2.167C-14.726,7.6 -6.307,10.285 2.548,10.285C16.419,10.285 26.139,2.925 26.139,-9.436L26.139,-9.625C26.139,-20.57 18.967,-25.572 5.002,-28.969C-7.737,-31.988 -10.757,-34.254 -10.757,-39.348L-10.757,-39.537C-10.757,-43.878 -6.793,-47.369 0,-47.369"}})]),_vm._v(" "),_c('g',{attrs:{"transform":"matrix(5.78669,0,0,5.78669,5032.44,-1618.3)"}},[_c('path',{staticStyle:{"fill":"rgb(0,113,206)","fill-rule":"nonzero","stroke":"rgb(0,113,206)","stroke-width":"0.7px"},attrs:{"d":"M477.439,422.947C479.868,422.947 481.796,420.943 481.796,418.564L481.796,418.539C481.796,416.16 479.893,414.181 477.439,414.181C475.009,414.181 473.081,416.185 473.081,418.564L473.081,418.589C473.081,420.968 474.984,422.947 477.439,422.947ZM477.439,422.571C475.185,422.571 473.482,420.768 473.482,418.564C473.482,416.385 475.21,414.557 477.439,414.557C479.693,414.557 481.396,416.36 481.396,418.564C481.396,420.743 479.668,422.571 477.439,422.571ZM475.836,420.693L476.312,420.693L476.312,418.99L477.639,418.99L478.916,420.693L479.517,420.693L478.19,418.914C478.816,418.764 479.342,418.338 479.342,417.612C479.342,416.736 478.616,416.31 477.739,416.31L475.836,416.31L475.836,420.693ZM476.312,418.564L476.312,416.736L477.689,416.736C478.415,416.736 478.866,417.061 478.866,417.637C478.866,418.213 478.39,418.564 477.664,418.564L476.312,418.564Z"}})])])])])])}
var staticRenderFns = []

// EXTERNAL MODULE: ./node_modules/vue-loader/lib/runtime/component-normalizer.js
var component_normalizer = __webpack_require__(14);

// CONCATENATED MODULE: ./src/components/LogoEnterpriseHqStack.vue
/* script */


/* template */

/* template functional */
var __vue_template_functional__ = false
/* styles */
var __vue_styles__ = null
/* scopeId */
var __vue_scopeId__ = null
/* moduleIdentifier (server only) */
var __vue_module_identifier__ = null

var Component = Object(component_normalizer["a" /* default */])(
  LogoEnterpriseHqStack,
  render,
  staticRenderFns,
  __vue_template_functional__,
  __vue_styles__,
  __vue_scopeId__,
  __vue_module_identifier__
)

/* harmony default export */ var components_LogoEnterpriseHqStack = __webpack_exports__["a"] = (Component.exports);


/***/ }),

/***/ 1431:
/***/ (function(module, exports, __webpack_require__) {

// style-loader: Adds some css to the DOM by adding a <style> tag

// load the styles
var content = __webpack_require__(1432);
if(content.__esModule) content = content.default;
if(typeof content === 'string') content = [[module.i, content, '']];
if(content.locals) module.exports = content.locals;
// add the styles to the DOM
var add = __webpack_require__(1003).default
var update = add("0bc730dc", content, true, {});

/***/ }),

/***/ 1432:
/***/ (function(module, exports, __webpack_require__) {

exports = module.exports = __webpack_require__(613)(true);
// imports


// module
exports.push([module.i, ".application[data-v-7df99fb9]{-webkit-transition:all .5s ease;transition:all .5s ease;background:#6c7884!important}.application[data-v-7df99fb9]:hover{background:#0e4a81!important}.btn[data-v-7df99fb9],.btn[data-v-7df99fb9]:first-child{-webkit-transition:unset;transition:unset}img[data-v-7df99fb9]{max-height:67px}img.qr-code[data-v-7df99fb9]{max-height:200px;height:200px;width:200px}.card[data-v-7df99fb9]{-webkit-transition:max-height .3s ease-in-out;transition:max-height .3s ease-in-out}button[data-v-7df99fb9]{-webkit-box-flex:initial;flex:initial;flex-basis:36px}.input-group[data-v-7df99fb9]{flex-basis:74px}.inOut-enter-active[data-v-7df99fb9],.inOut-leave-active[data-v-7df99fb9]{-webkit-transition:all .3s ease-in-out;transition:all .3s ease-in-out;max-height:80px}.inOut-enter[data-v-7df99fb9],.inOut-leave-to[data-v-7df99fb9]{opacity:0;-webkit-transform:scale(0);transform:scale(0);max-height:0}", "", {"version":3,"sources":["/home/vishal/Documents/work/LENS_workspace/lens3/lens-frontend/src/screens/Login.vue"],"names":[],"mappings":"AACA,8BACE,gCAAkC,AAClC,wBAA0B,AAC1B,4BAA+B,CAChC,AACD,oCACE,4BAA+B,CAChC,AACD,wDAGE,yBAA0B,AAC1B,gBAAkB,CACnB,AACD,qBACE,eAAiB,CAClB,AACD,6BACE,iBAAkB,AAClB,aAAc,AACd,WAAa,CACd,AACD,uBACE,8CAAgD,AAChD,qCAAwC,CACzC,AACD,wBAEE,yBAA0B,AAClB,aAAc,AAEtB,eAAiB,CAClB,AACD,8BAEE,eAAiB,CAClB,AACD,0EAEE,uCAAyC,AACzC,+BAAiC,AACjC,eAAiB,CAClB,AACD,+DAEE,UAAW,AACX,2BAA4B,AACpB,mBAAoB,AAC5B,YAAgB,CACjB","file":"Login.vue","sourcesContent":["\n.application[data-v-7df99fb9] {\n  -webkit-transition: all 0.5s ease;\n  transition: all 0.5s ease;\n  background: #6c7884 !important;\n}\n.application[data-v-7df99fb9]:hover {\n  background: #0e4a81 !important;\n}\n.btn[data-v-7df99fb9],\n.btn[data-v-7df99fb9]:first-child {\n  /* Remove transition because of bad performance */\n  -webkit-transition: unset;\n  transition: unset;\n}\nimg[data-v-7df99fb9] {\n  max-height: 67px;\n}\nimg.qr-code[data-v-7df99fb9] {\n  max-height: 200px;\n  height: 200px;\n  width: 200px;\n}\n.card[data-v-7df99fb9] {\n  -webkit-transition: max-height 0.3s ease-in-out;\n  transition: max-height 0.3s ease-in-out;\n}\nbutton[data-v-7df99fb9] {\n  /* Fix height issue in Firefox */\n  -webkit-box-flex: initial;\n          flex: initial;\n  /* Fix IE display issue */\n  flex-basis: 36px;\n}\n.input-group[data-v-7df99fb9] {\n  /* Fix IE display issue */\n  flex-basis: 74px;\n}\n.inOut-enter-active[data-v-7df99fb9],\n.inOut-leave-active[data-v-7df99fb9] {\n  -webkit-transition: all 0.3s ease-in-out;\n  transition: all 0.3s ease-in-out;\n  max-height: 80px;\n}\n.inOut-enter[data-v-7df99fb9],\n.inOut-leave-to[data-v-7df99fb9] {\n  opacity: 0;\n  -webkit-transform: scale(0);\n          transform: scale(0);\n  max-height: 0px;\n}\n"],"sourceRoot":""}]);

// exports


/***/ }),

/***/ 1945:
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
Object.defineProperty(__webpack_exports__, "__esModule", { value: true });

// EXTERNAL MODULE: ./node_modules/delay/index.js
var delay = __webpack_require__(229);
var delay_default = /*#__PURE__*/__webpack_require__.n(delay);

// EXTERNAL MODULE: ./node_modules/vuelidate/lib/index.js
var lib = __webpack_require__(945);
var lib_default = /*#__PURE__*/__webpack_require__.n(lib);

// EXTERNAL MODULE: ./node_modules/vuelidate/lib/validators/index.js
var validators = __webpack_require__(700);
var validators_default = /*#__PURE__*/__webpack_require__.n(validators);

// EXTERNAL MODULE: ./src/components/LogoEnterpriseHqStack.vue + 2 modules
var LogoEnterpriseHqStack = __webpack_require__(1235);

// EXTERNAL MODULE: ./src/store/session.js
var session = __webpack_require__(17);

// EXTERNAL MODULE: ./src/store/users.js
var users = __webpack_require__(233);

// CONCATENATED MODULE: ./node_modules/babel-loader/lib!./node_modules/vue-loader/lib/selector.js?type=script&index=0!./src/screens/Login.vue
function _asyncToGenerator(fn) { return function () { var gen = fn.apply(this, arguments); return new Promise(function (resolve, reject) { function step(key, arg) { try { var info = gen[key](arg); var value = info.value; } catch (error) { reject(error); return; } if (info.done) { resolve(value); } else { return Promise.resolve(value).then(function (value) { step("next", value); }, function (err) { step("throw", err); }); } } return step("next"); }); }; }

//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//



// $FlowFixMe






var loginButtonText = 'Log in';
var resetPasswordButtonText = 'Reset My Password';
var setPasswordButtonText = 'Set Password';

/* harmony default export */ var Login = ({
  name: 'Login',
  mixins: [lib["validationMixin"]],
  validations: function validations() {
    if (this.resettingPassword) {
      return { email: { required: validators["required"] } };
    } else if (this.settingPassword) {
      return { password: { required: validators["required"], minLength: Object(validators["minLength"])(8) } };
    } else {
      return { email: { required: validators["required"] }, password: { required: validators["required"] } };
    }
  },
  data: function data() {
    return {
      email: '',
      password: '',
      passwordVisible: false,
      success: false,
      submitButtonText: '',
      errorMessage: '',
      accountLocked: false,
      mfaCodeRequired: false,
      google_mfa: {},
      showQRcode: false,
      mfa_code: null
    };
  },

  computed: {
    resettingPassword: function resettingPassword() {
      return this.$route.path === '/reset-password';
    },
    settingPassword: function settingPassword() {
      return this.$route.path === '/set-password';
    },
    expiredPassword: function expiredPassword() {
      return !!this.$route.query.expired_password;
    }
  },
  mounted: function mounted() {
    this.setInitialButtonText();
    this.setInitialFocus();
  },

  watch: {
    '$route.path': function () {
      var _ref = _asyncToGenerator( /*#__PURE__*/regeneratorRuntime.mark(function _callee() {
        return regeneratorRuntime.wrap(function _callee$(_context) {
          while (1) {
            switch (_context.prev = _context.next) {
              case 0:
                this.setInitialButtonText();
                this.success = false;
                this.errorMessage = '';
                _context.next = 5;
                return this.$nextTick();

              case 5:
                this.setInitialFocus();

              case 6:
              case 'end':
                return _context.stop();
            }
          }
        }, _callee, this);
      }));

      function $routePath() {
        return _ref.apply(this, arguments);
      }

      return $routePath;
    }()
  },
  methods: {
    clickQRCodeConfirm: function clickQRCodeConfirm() {
      this.errorMessage = '';
      this.submitButtonText = 'LOG IN';
      this.mfaCodeRequired = true;
      this.showQRcode = false;
    },
    clickQRCodeCancel: function clickQRCodeCancel() {
      this.errorMessage = '';
      this.submitButtonText = 'LOG IN';
      this.mfaCodeRequired = false;
      this.showQRcode = false;
    },
    setInitialFocus: function setInitialFocus() {
      if (this.resettingPassword) {
        this.$refs.email && this.$refs.email.focus();
      } else if (this.settingPassword) {
        this.submitButtonText = setPasswordButtonText;
        this.$refs.password && this.$refs.password.focus();
      } else {
        this.$refs.email && this.$refs.email.focus();
      }
    },
    setInitialButtonText: function setInitialButtonText() {
      if (this.resettingPassword) {
        this.submitButtonText = resetPasswordButtonText;
      } else if (this.settingPassword) {
        this.submitButtonText = setPasswordButtonText;
      } else {
        this.submitButtonText = loginButtonText;
      }
    },
    handleSetPassword: function () {
      var _ref2 = _asyncToGenerator( /*#__PURE__*/regeneratorRuntime.mark(function _callee2() {
        var _ref3, success, error, meta;

        return regeneratorRuntime.wrap(function _callee2$(_context2) {
          while (1) {
            switch (_context2.prev = _context2.next) {
              case 0:
                this.errorMessage = '';
                this.submitButtonText = 'Setting password...';
                _context2.next = 4;
                return this.$store.dispatch(users["g" /* USER_RESET_PASSWORD */], {
                  reset_password_token: this.$route.query.reset_password_token,
                  new_password: this.password
                });

              case 4:
                _ref3 = _context2.sent;
                success = _ref3.success;
                error = _ref3.error;
                meta = _ref3.meta;

                if (!success) {
                  _context2.next = 16;
                  break;
                }

                this.success = true;
                this.submitButtonText = 'Success! Logging in...';
                _context2.next = 13;
                return this.$store.dispatch(session["b" /* NEW_SESSION_FROM_META_OBJECT */], meta);

              case 13:
                this.loginFlow();
                _context2.next = 18;
                break;

              case 16:
                this.errorMessage = error;
                this.setInitialButtonText();

              case 18:
              case 'end':
                return _context2.stop();
            }
          }
        }, _callee2, this);
      }));

      function handleSetPassword() {
        return _ref2.apply(this, arguments);
      }

      return handleSetPassword;
    }(),
    loginFlow: function () {
      var _ref4 = _asyncToGenerator( /*#__PURE__*/regeneratorRuntime.mark(function _callee3() {
        var redirect;
        return regeneratorRuntime.wrap(function _callee3$(_context3) {
          while (1) {
            switch (_context3.prev = _context3.next) {
              case 0:
                _context3.next = 2;
                return delay_default()(200);

              case 2:
                redirect = this.$route.query.redirect;

                if (redirect && redirect.includes('redirect')) {
                  // Sometimes the redirect query string will get filled with nested redirect queries. Not sure why,
                  // but when it happens, it breaks the login button. This is a workaround
                  redirect = null;
                }
                this.$router.push(redirect || '/dashboard');

              case 5:
              case 'end':
                return _context3.stop();
            }
          }
        }, _callee3, this);
      }));

      function loginFlow() {
        return _ref4.apply(this, arguments);
      }

      return loginFlow;
    }(),
    submit: function () {
      var _ref5 = _asyncToGenerator( /*#__PURE__*/regeneratorRuntime.mark(function _callee4() {
        var _ref6, success, error, _ref7, _success, _error, meta, _ref8, _success2, _error2, _meta, reset_password_token, google_mfa;

        return regeneratorRuntime.wrap(function _callee4$(_context4) {
          while (1) {
            switch (_context4.prev = _context4.next) {
              case 0:
                if (!this.$v.$invalid) {
                  _context4.next = 2;
                  break;
                }

                return _context4.abrupt('return');

              case 2:
                if (!this.resettingPassword) {
                  _context4.next = 13;
                  break;
                }

                this.errorMessage = '';
                this.submitButtonText = 'Sending reset email...';
                _context4.next = 7;
                return this.$store.dispatch(users["f" /* USER_FORGOT_PASSWORD */], {
                  email: this.email
                });

              case 7:
                _ref6 = _context4.sent;
                success = _ref6.success;
                error = _ref6.error;

                if (success) {
                  this.success = true;
                  this.submitButtonText = 'Success! Check your email';
                } else {
                  this.errorMessage = error;
                  this.setInitialButtonText();
                }
                _context4.next = 50;
                break;

              case 13:
                if (!(this.settingPassword && this.$route.query.reset_password_token)) {
                  _context4.next = 17;
                  break;
                }

                this.handleSetPassword();
                _context4.next = 50;
                break;

              case 17:
                if (!(this.settingPassword && this.$route.query.new_user_token)) {
                  _context4.next = 38;
                  break;
                }

                this.errorMessage = '';
                this.submitButtonText = 'Setting password...';
                _context4.next = 22;
                return this.$store.dispatch(users["h" /* VERIFY_NEW_USER */], {
                  new_user_token: this.$route.query.new_user_token,
                  new_password: this.password
                });

              case 22:
                _ref7 = _context4.sent;
                _success = _ref7.success;
                _error = _ref7.error;
                meta = _ref7.meta;

                if (!_success) {
                  _context4.next = 34;
                  break;
                }

                this.success = true;
                this.submitButtonText = 'Success! Logging in...';
                _context4.next = 31;
                return this.$store.dispatch(session["b" /* NEW_SESSION_FROM_META_OBJECT */], meta);

              case 31:
                this.loginFlow();
                _context4.next = 36;
                break;

              case 34:
                this.errorMessage = _error;
                this.setInitialButtonText();

              case 36:
                _context4.next = 50;
                break;

              case 38:
                this.errorMessage = '';
                this.submitButtonText = 'Authenticating...';
                _context4.next = 42;
                return this.$store.dispatch(session["a" /* CREATE_SESSION */], {
                  email: this.email,
                  password: this.password,
                  mfa_code: this.mfa_code
                });

              case 42:
                _ref8 = _context4.sent;
                _success2 = _ref8.success;
                _error2 = _ref8.error;
                _meta = _ref8.meta;
                reset_password_token = _ref8.reset_password_token;

                console.log(reset_password_token);
                google_mfa = _meta && _meta.google_mfa;

                if (google_mfa && google_mfa.google_mfa_secret) {
                  if (google_mfa.acknowledge_secret_please) {}
                  // show a popup noting mfa and showing qr code
                  this.google_mfa = google_mfa;
                  this.showQRcode = true;
                } else if (google_mfa && google_mfa.mfa_code_required) {
                  this.submitButtonText = 'Verify Code';
                  this.mfaCodeRequired = true;
                } else if (_success2) {
                  this.success = true;
                  this.submitButtonText = 'Success!';
                  this.loginFlow();
                } else if (reset_password_token) {
                  this.mfa_code = null;
                  this.mfaCodeRequired = false;
                  this.$router.push("/set-password?expired_password=1&reset_password_token=" + reset_password_token);
                } else {
                  this.errorMessage = _error2;
                  this.setInitialButtonText();
                }

              case 50:
              case 'end':
                return _context4.stop();
            }
          }
        }, _callee4, this);
      }));

      function submit() {
        return _ref5.apply(this, arguments);
      }

      return submit;
    }()
  },
  components: {
    LogoEnterpriseHqStack: LogoEnterpriseHqStack["a" /* default */]
  }
});
// CONCATENATED MODULE: ./node_modules/vue-loader/lib/template-compiler?{"id":"data-v-7df99fb9","hasScoped":true,"optionsId":"0","buble":{"transforms":{}}}!./node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/screens/Login.vue
var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('v-app',[_c('div',{staticClass:"application flex flex-column justify-center items-center"},[_c('form',{staticClass:"flex flex-none flex-column items-center p1",staticStyle:{"width":"100%","max-width":"500px"},on:{"submit":function($event){$event.preventDefault();return _vm.submit.apply(null, arguments)}}},[_c('v-card',{staticClass:"flex flex-column flex-none items-center bg-white elevation-15",class:_vm.$mq.xs ? 'p3' : 'p4',staticStyle:{"width":"100%"}},[_c('LogoEnterpriseHqStack',{staticStyle:{"margin":"24px 32px 48px"}}),_vm._v(" "),_c('v-dialog',{attrs:{"width":"660px"},model:{value:(_vm.showQRcode),callback:function ($$v) {_vm.showQRcode=$$v},expression:"showQRcode"}},[_c('v-card',[_c('v-card-title',[_c('h2',[_vm._v("Multi-Factor Authorization")])]),_vm._v(" "),_c('v-divider'),_vm._v(" "),_c('v-card-text',[_c('div',[_vm._v("Your system administrator has enabled multi-factor authorization for your LENS account.")]),_vm._v(" "),_c('div',[_vm._v("In order to log in to your LENS account, you will need to do the following:")]),_vm._v(" "),_c('p'),_vm._v(" "),_c('div',{staticStyle:{"margin-left":"15px"}},[_c('ul',[_c('li',[_vm._v("Install Google Authenticator onto your smart phone or other device.")]),_vm._v(" "),_c('li',[_vm._v("Enter the following code into Google Authenticator. You can do that by showing Authenticator the following QR code, or by typing the issuer, Authorizer Name and Google Secret below into Authenticator.")])])]),_vm._v(" "),_c('div',[_c('img',{staticClass:"qr-code",attrs:{"src":_vm.google_mfa.google_qr_uri}})]),_vm._v(" "),_c('div',{staticStyle:{"margin-left":"15px"}},[_c('table',[_c('tr',[_c('td',[_c('strong',[_vm._v("Issuer:")])]),_c('td',[_vm._v(_vm._s(_vm.google_mfa.google_mfa_issuer))])]),_vm._v(" "),_c('tr',[_c('td',[_c('strong',[_vm._v("Authorizer Name:")])]),_c('td',[_vm._v(_vm._s(_vm.google_mfa.google_auth_name))])]),_vm._v(" "),_c('tr',[_c('td',[_c('strong',[_vm._v("Google Secret:")])]),_c('td',[_vm._v(_vm._s(_vm.google_mfa.google_mfa_secret))])])]),_vm._v(" "),_c('br'),_vm._v(" "),_c('ul',[_c('li',[_vm._v("After entering the code into Google Authenticator you should be ready to login with multi-factor authorization.")]),_vm._v(" "),_c('li',[_vm._v("Click OK.")]),_vm._v(" "),_c('li',[_vm._v("Enter your email/password as usual.")]),_vm._v(" "),_c('li',[_vm._v("You will be prompted to enter a multi-factor code.")]),_vm._v(" "),_c('li',[_vm._v("On your device, request a new code, and enter it where prompted.")]),_vm._v(" "),_c('li',[_vm._v("You should be successfully logged in.")]),_vm._v(" "),_c('li',[_c('strong',[_vm._v("Note: "),_c('span',{staticStyle:{"color":"red"}},[_vm._v("After clicking \"OK\", you will not be shown this QR code and Google Secret again.")])])])])])]),_vm._v(" "),_c('v-divider'),_vm._v(" "),_c('v-card-actions',[_c('v-btn',{attrs:{"color":"green","tile":""},on:{"click":function($event){return _vm.clickQRCodeConfirm()}}},[_vm._v("OK")]),_vm._v(" "),_c('v-spacer'),_vm._v(" "),_c('v-btn',{attrs:{"color":"grey","tile":""},on:{"click":function($event){return _vm.clickQRCodeCancel()}}},[_vm._v("Cancel")])],1)],1)],1),_vm._v(" "),_c('transition',{attrs:{"name":"inOut"}},[(!_vm.settingPassword)?_c('div',{staticStyle:{"width":"100%"}},[_c('v-text-field',{ref:"email",attrs:{"label":"Email","type":"email"},model:{value:(_vm.email),callback:function ($$v) {_vm.email=(typeof $$v === 'string'? $$v.trim(): $$v)},expression:"email"}})],1):_vm._e()]),_vm._v(" "),_c('transition',{attrs:{"name":"inOut"}},[(!_vm.resettingPassword)?_c('div',{staticStyle:{"width":"100%"}},[(_vm.expiredPassword)?_c('p',{attrs:{"color":"red"}},[_vm._v("Your password has expired. You must set a new password to continue. Passwords expire after 90 days.")]):_vm._e(),_vm._v(" "),_c('v-text-field',{ref:"password",attrs:{"label":_vm.settingPassword ? 'Set Your New Password' : 'Password',"append-icon":_vm.passwordVisible ? 'mdi-eye' : 'mdi-eye-off',"type":_vm.passwordVisible ? 'text' : 'password',"hint":_vm.settingPassword ? 'Must have at least 10 characters, including at least 1 lowercase, 1 uppercase, 1 special character and 1 digit' : ''},on:{"click:append":function($event){_vm.passwordVisible = !_vm.passwordVisible}},model:{value:(_vm.password),callback:function ($$v) {_vm.password=(typeof $$v === 'string'? $$v.trim(): $$v)},expression:"password"}})],1):_vm._e()]),_vm._v(" "),_c('transition',{attrs:{"name":"inOut"}},[(!_vm.resettingPassword && _vm.mfaCodeRequired && !_vm.expiredPassword)?_c('div',{staticStyle:{"width":"100%"}},[_c('v-text-field',{ref:"text",attrs:{"label":"Two-Factor Authorization Code","type":"text"},model:{value:(_vm.mfa_code),callback:function ($$v) {_vm.mfa_code=(typeof $$v === 'string'? $$v.trim(): $$v)},expression:"mfa_code"}})],1):_vm._e()]),_vm._v(" "),_c('transition',{attrs:{"name":"inOut"}},[(_vm.errorMessage)?_c('p',{staticClass:"center error-text"},[_vm._v("\n            "+_vm._s(_vm.errorMessage)+"\n          ")]):_vm._e()]),_vm._v(" "),_c('div',{staticStyle:{"width":"100%"}},[_c('v-btn',{attrs:{"type":"submit","color":_vm.success ? 'success' : 'primary',"block":"","outlined":"","disabled":_vm.$v.$invalid}},[_vm._v("\n            "+_vm._s(_vm.submitButtonText)+"\n          ")])],1)],1),_vm._v(" "),_c('div',{staticClass:"mt2"},[_c('v-btn',{staticClass:"m0",attrs:{"text":"","color":"white","to":{path: _vm.resettingPassword || _vm.settingPassword ? '/login' : '/reset-password', query: _vm.$route.query}}},[(_vm.resettingPassword || _vm.settingPassword)?_c('span',{key:"1"},[_vm._v("Log in")]):_c('span',{key:"2"},[_vm._v("Reset my password")])])],1)],1)])])}
var staticRenderFns = []

// EXTERNAL MODULE: ./node_modules/vue-loader/lib/runtime/component-normalizer.js
var component_normalizer = __webpack_require__(14);

// CONCATENATED MODULE: ./src/screens/Login.vue
function injectStyle (context) {
  __webpack_require__(1431)
}
/* script */


/* template */

/* template functional */
var __vue_template_functional__ = false
/* styles */
var __vue_styles__ = injectStyle
/* scopeId */
var __vue_scopeId__ = "data-v-7df99fb9"
/* moduleIdentifier (server only) */
var __vue_module_identifier__ = null

var Component = Object(component_normalizer["a" /* default */])(
  Login,
  render,
  staticRenderFns,
  __vue_template_functional__,
  __vue_styles__,
  __vue_scopeId__,
  __vue_module_identifier__
)

/* harmony default export */ var screens_Login = __webpack_exports__["default"] = (Component.exports);


/***/ }),

/***/ 627:
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.regex = exports.ref = exports.len = exports.req = exports.withParams = undefined;

var _withParams = __webpack_require__(713);

var _withParams2 = _interopRequireDefault(_withParams);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

exports.withParams = _withParams2.default;

// "required" core, used in almost every validator to allow empty values

var req = exports.req = function req(value) {
  if (Array.isArray(value)) return !!value.length;
  if (value === undefined || value === null || value === false) {
    return false;
  }

  if (value instanceof Date) {
    // invalid date won't pass
    return !isNaN(value.getTime());
  }

  if (typeof value === 'object') {
    for (var _ in value) {
      return true;
    }return false;
  }

  return !!String(value).length;
};

// get length in type-agnostic way
var len = exports.len = function len(value) {
  if (Array.isArray(value)) return value.length;
  if (typeof value === 'object') {
    return Object.keys(value).length;
  }
  return String(value).length;
};

// resolve referenced value
var ref = exports.ref = function ref(reference, vm, parentVm) {
  return typeof reference === 'function' ? reference.call(vm, parentVm) : parentVm[reference];
};

// regex based validator template
var regex = exports.regex = function regex(type, expr) {
  return (0, _withParams2.default)({ type: type }, function (value) {
    return !req(value) || expr.test(value);
  });
};

/***/ }),

/***/ 689:
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});

var _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; };

exports.pushParams = pushParams;
exports.popParams = popParams;
exports.withParams = withParams;

var stack = [];

// exported for tests
var target = exports.target = null;
var _setTarget = exports._setTarget = function _setTarget(x) {
  exports.target = target = x;
};

function pushParams() {
  if (target !== null) {
    stack.push(target);
  }
  exports.target = target = {};
}

function popParams() {
  var lastTarget = target;
  var newTarget = exports.target = target = stack.pop() || null;
  if (newTarget) {
    if (!Array.isArray(newTarget.$sub)) {
      newTarget.$sub = [];
    }
    newTarget.$sub.push(lastTarget);
  }
  return lastTarget;
}

function addParams(params) {
  if (typeof params === 'object' && !Array.isArray(params)) {
    exports.target = target = _extends({}, target, params);
  } else {
    throw new Error('params must be an object');
  }
}

function withParamsDirect(params, validator) {
  return withParamsClosure(function (add) {
    return function () {
      add(params);

      for (var _len = arguments.length, args = Array(_len), _key = 0; _key < _len; _key++) {
        args[_key] = arguments[_key];
      }

      return validator.apply(this, args);
    };
  });
}

function withParamsClosure(closure) {
  var validator = closure(addParams);
  return function () {
    pushParams();
    try {
      for (var _len2 = arguments.length, args = Array(_len2), _key2 = 0; _key2 < _len2; _key2++) {
        args[_key2] = arguments[_key2];
      }

      return validator.apply(this, args);
    } finally {
      popParams();
    }
  };
}

function withParams(paramsOrClosure, maybeValidator) {
  if (typeof paramsOrClosure === 'object' && maybeValidator !== undefined) {
    return withParamsDirect(paramsOrClosure, maybeValidator);
  }
  return withParamsClosure(paramsOrClosure);
}

/***/ }),

/***/ 700:
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.maxValue = exports.minValue = exports.and = exports.or = exports.url = exports.sameAs = exports.requiredUnless = exports.requiredIf = exports.required = exports.minLength = exports.maxLength = exports.macAddress = exports.ipAddress = exports.email = exports.between = exports.numeric = exports.alphaNum = exports.alpha = undefined;

var _alpha = __webpack_require__(712);

var _alpha2 = _interopRequireDefault(_alpha);

var _alphaNum = __webpack_require__(714);

var _alphaNum2 = _interopRequireDefault(_alphaNum);

var _numeric = __webpack_require__(715);

var _numeric2 = _interopRequireDefault(_numeric);

var _between = __webpack_require__(716);

var _between2 = _interopRequireDefault(_between);

var _email = __webpack_require__(717);

var _email2 = _interopRequireDefault(_email);

var _ipAddress = __webpack_require__(718);

var _ipAddress2 = _interopRequireDefault(_ipAddress);

var _macAddress = __webpack_require__(719);

var _macAddress2 = _interopRequireDefault(_macAddress);

var _maxLength = __webpack_require__(720);

var _maxLength2 = _interopRequireDefault(_maxLength);

var _minLength = __webpack_require__(721);

var _minLength2 = _interopRequireDefault(_minLength);

var _required = __webpack_require__(722);

var _required2 = _interopRequireDefault(_required);

var _requiredIf = __webpack_require__(723);

var _requiredIf2 = _interopRequireDefault(_requiredIf);

var _requiredUnless = __webpack_require__(724);

var _requiredUnless2 = _interopRequireDefault(_requiredUnless);

var _sameAs = __webpack_require__(725);

var _sameAs2 = _interopRequireDefault(_sameAs);

var _url = __webpack_require__(726);

var _url2 = _interopRequireDefault(_url);

var _or = __webpack_require__(727);

var _or2 = _interopRequireDefault(_or);

var _and = __webpack_require__(728);

var _and2 = _interopRequireDefault(_and);

var _minValue = __webpack_require__(729);

var _minValue2 = _interopRequireDefault(_minValue);

var _maxValue = __webpack_require__(730);

var _maxValue2 = _interopRequireDefault(_maxValue);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

exports.alpha = _alpha2.default;
exports.alphaNum = _alphaNum2.default;
exports.numeric = _numeric2.default;
exports.between = _between2.default;
exports.email = _email2.default;
exports.ipAddress = _ipAddress2.default;
exports.macAddress = _macAddress2.default;
exports.maxLength = _maxLength2.default;
exports.minLength = _minLength2.default;
exports.required = _required2.default;
exports.requiredIf = _requiredIf2.default;
exports.requiredUnless = _requiredUnless2.default;
exports.sameAs = _sameAs2.default;
exports.url = _url2.default;
exports.or = _or2.default;
exports.and = _and2.default;
exports.minValue = _minValue2.default;
exports.maxValue = _maxValue2.default;

/***/ }),

/***/ 712:
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});

var _common = __webpack_require__(627);

exports.default = (0, _common.regex)('alpha', /^[a-zA-Z]*$/);

/***/ }),

/***/ 713:
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});
/* istanbul ignore next */
var withParams =  false ? require('./withParamsBrowser').withParams : __webpack_require__(689).withParams;

exports.default = withParams;

/***/ }),

/***/ 714:
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});

var _common = __webpack_require__(627);

exports.default = (0, _common.regex)('alphaNum', /^[a-zA-Z0-9]*$/);

/***/ }),

/***/ 715:
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});

var _common = __webpack_require__(627);

exports.default = (0, _common.regex)('numeric', /^[0-9]*$/);

/***/ }),

/***/ 716:
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});

var _common = __webpack_require__(627);

exports.default = function (min, max) {
  return (0, _common.withParams)({ type: 'between', min: min, max: max }, function (value) {
    return !(0, _common.req)(value) || (!/\s/.test(value) || value instanceof Date) && +min <= +value && +max >= +value;
  });
};

/***/ }),

/***/ 717:
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});

var _common = __webpack_require__(627);

var emailRegex = /(^$|^(([^<>()[\]\\.,;:\s@"]+(\.[^<>()[\]\\.,;:\s@"]+)*)|(".+"))@((\[[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}])|(([a-zA-Z\-0-9]+\.)+[a-zA-Z]{2,}))$)/;

exports.default = (0, _common.regex)('email', emailRegex);

/***/ }),

/***/ 718:
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});

var _common = __webpack_require__(627);

exports.default = (0, _common.withParams)({ type: 'ipAddress' }, function (value) {
  if (!(0, _common.req)(value)) {
    return true;
  }

  if (typeof value !== 'string') {
    return false;
  }

  var nibbles = value.split('.');
  return nibbles.length === 4 && nibbles.every(nibbleValid);
});


var nibbleValid = function nibbleValid(nibble) {
  if (nibble.length > 3 || nibble.length === 0) {
    return false;
  }

  if (nibble[0] === '0' && nibble !== '0') {
    return false;
  }

  if (!nibble.match(/^\d+$/)) {
    return false;
  }

  var numeric = +nibble | 0;
  return numeric >= 0 && numeric <= 255;
};

/***/ }),

/***/ 719:
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});

var _common = __webpack_require__(627);

exports.default = function () {
  var separator = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : ':';
  return (0, _common.withParams)({ type: 'macAddress' }, function (value) {
    if (!(0, _common.req)(value)) {
      return true;
    }

    if (typeof value !== 'string') {
      return false;
    }

    var parts = typeof separator === 'string' && separator !== '' ? value.split(separator) : value.length === 12 || value.length === 16 ? value.match(/.{2}/g) : null;

    return parts !== null && (parts.length === 6 || parts.length === 8) && parts.every(hexValid);
  });
};

var hexValid = function hexValid(hex) {
  return hex.toLowerCase().match(/^[0-9a-f]{2}$/);
};

/***/ }),

/***/ 720:
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});

var _common = __webpack_require__(627);

exports.default = function (length) {
  return (0, _common.withParams)({ type: 'maxLength', max: length }, function (value) {
    return !(0, _common.req)(value) || (0, _common.len)(value) <= length;
  });
};

/***/ }),

/***/ 721:
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});

var _common = __webpack_require__(627);

exports.default = function (length) {
  return (0, _common.withParams)({ type: 'minLength', min: length }, function (value) {
    return !(0, _common.req)(value) || (0, _common.len)(value) >= length;
  });
};

/***/ }),

/***/ 722:
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});

var _common = __webpack_require__(627);

exports.default = (0, _common.withParams)({ type: 'required' }, _common.req);

/***/ }),

/***/ 723:
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});

var _common = __webpack_require__(627);

exports.default = function (prop) {
  return (0, _common.withParams)({ type: 'requiredIf', prop: prop }, function (value, parentVm) {
    return (0, _common.ref)(prop, this, parentVm) ? (0, _common.req)(value) : true;
  });
};

/***/ }),

/***/ 724:
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});

var _common = __webpack_require__(627);

exports.default = function (prop) {
  return (0, _common.withParams)({ type: 'requiredUnless', prop: prop }, function (value, parentVm) {
    return !(0, _common.ref)(prop, this, parentVm) ? (0, _common.req)(value) : true;
  });
};

/***/ }),

/***/ 725:
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});

var _common = __webpack_require__(627);

exports.default = function (equalTo) {
  return (0, _common.withParams)({ type: 'sameAs', eq: equalTo }, function (value, parentVm) {
    return value === (0, _common.ref)(equalTo, this, parentVm);
  });
};

/***/ }),

/***/ 726:
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});

var _common = __webpack_require__(627);

var urlRegex = /^(?:(?:https?|ftp):\/\/)(?:\S+(?::\S*)?@)?(?:(?!(?:10|127)(?:\.\d{1,3}){3})(?!(?:169\.254|192\.168)(?:\.\d{1,3}){2})(?!172\.(?:1[6-9]|2\d|3[0-1])(?:\.\d{1,3}){2})(?:[1-9]\d?|1\d\d|2[01]\d|22[0-3])(?:\.(?:1?\d{1,2}|2[0-4]\d|25[0-5])){2}(?:\.(?:[1-9]\d?|1\d\d|2[0-4]\d|25[0-4]))|(?:(?:[a-z\u00a1-\uffff0-9]-*)*[a-z\u00a1-\uffff0-9]+)(?:\.(?:[a-z\u00a1-\uffff0-9]-*)*[a-z\u00a1-\uffff0-9]+)*(?:\.(?:[a-z\u00a1-\uffff]{2,})))(?::\d{2,5})?(?:[/?#]\S*)?$/i;

exports.default = (0, _common.regex)('url', urlRegex);

/***/ }),

/***/ 727:
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});

var _common = __webpack_require__(627);

exports.default = function () {
  for (var _len = arguments.length, validators = Array(_len), _key = 0; _key < _len; _key++) {
    validators[_key] = arguments[_key];
  }

  return (0, _common.withParams)({ type: 'or' }, function () {
    var _this = this;

    for (var _len2 = arguments.length, args = Array(_len2), _key2 = 0; _key2 < _len2; _key2++) {
      args[_key2] = arguments[_key2];
    }

    return validators.length > 0 && validators.reduce(function (valid, fn) {
      return valid || fn.apply(_this, args);
    }, false);
  });
};

/***/ }),

/***/ 728:
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});

var _common = __webpack_require__(627);

exports.default = function () {
  for (var _len = arguments.length, validators = Array(_len), _key = 0; _key < _len; _key++) {
    validators[_key] = arguments[_key];
  }

  return (0, _common.withParams)({ type: 'and' }, function () {
    var _this = this;

    for (var _len2 = arguments.length, args = Array(_len2), _key2 = 0; _key2 < _len2; _key2++) {
      args[_key2] = arguments[_key2];
    }

    return validators.length > 0 && validators.reduce(function (valid, fn) {
      return valid && fn.apply(_this, args);
    }, true);
  });
};

/***/ }),

/***/ 729:
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});

var _common = __webpack_require__(627);

exports.default = function (min) {
  return (0, _common.withParams)({ type: 'minValue', min: min }, function (value) {
    return !(0, _common.req)(value) || (!/\s/.test(value) || value instanceof Date) && +value >= +min;
  });
};

/***/ }),

/***/ 730:
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});

var _common = __webpack_require__(627);

exports.default = function (max) {
  return (0, _common.withParams)({ type: 'maxValue', max: max }, function (value) {
    return !(0, _common.req)(value) || (!/\s/.test(value) || value instanceof Date) && +value <= +max;
  });
};

/***/ }),

/***/ 945:
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.withParams = exports.validationMixin = exports.Vuelidate = undefined;

var _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; };

var _vval = __webpack_require__(946);

var _params = __webpack_require__(689);

var NUL = function NUL() {
  return null;
};

var buildFromKeys = function buildFromKeys(keys, fn, keyFn) {
  return keys.reduce(function (build, key) {
    build[keyFn ? keyFn(key) : key] = fn(key);
    return build;
  }, {});
};

function isFunction(val) {
  return typeof val === 'function';
}

function isObject(val) {
  return val !== null && (typeof val === 'object' || isFunction(val));
}

function isPromise(object) {
  return isObject(object) && isFunction(object.then);
}

var getPath = function getPath(ctx, obj, path, fallback) {
  if (typeof path === 'function') {
    return path.call(ctx, obj, fallback);
  }

  path = Array.isArray(path) ? path : path.split('.');
  for (var i = 0; i < path.length; i++) {
    if (obj && typeof obj === 'object') {
      obj = obj[path[i]];
    } else {
      return fallback;
    }
  }

  return typeof obj === 'undefined' ? fallback : obj;
};

var __isVuelidateAsyncVm = '__isVuelidateAsyncVm';
function makePendingAsyncVm(Vue, promise) {
  var asyncVm = new Vue({
    data: {
      p: true, // pending
      v: false // value
    }
  });

  promise.then(function (value) {
    asyncVm.p = false;
    asyncVm.v = value;
  }, function (error) {
    asyncVm.p = false;
    asyncVm.v = false;
    throw error;
  });

  asyncVm[__isVuelidateAsyncVm] = true;
  return asyncVm;
}

var validationGetters = {
  $invalid: function $invalid() {
    var _this = this;

    var proxy = this.proxy;
    return this.nestedKeys.some(function (nested) {
      return _this.refProxy(nested).$invalid;
    }) || this.ruleKeys.some(function (rule) {
      return !proxy[rule];
    });
  },
  $dirty: function $dirty() {
    var _this2 = this;

    if (this.dirty) {
      return true;
    }
    if (this.nestedKeys.length === 0) {
      return false;
    }

    return this.nestedKeys.every(function (key) {
      return _this2.refProxy(key).$dirty;
    });
  },
  $error: function $error() {
    return this.$dirty && !this.$pending && this.$invalid;
  },
  $pending: function $pending() {
    var _this3 = this;

    return this.ruleKeys.some(function (key) {
      return _this3.getRef(key).$pending;
    }) || this.nestedKeys.some(function (key) {
      return _this3.refProxy(key).$pending;
    });
  },
  $params: function $params() {
    var _this4 = this;

    var vals = this.validations;
    return _extends({}, buildFromKeys(this.nestedKeys, function (key) {
      return vals[key] && vals[key].$params || null;
    }), buildFromKeys(this.ruleKeys, function (key) {
      return _this4.getRef(key).$params;
    }));
  }
};

function setDirtyRecursive(newState) {
  this.dirty = newState;
  var proxy = this.proxy;
  var method = newState ? '$touch' : '$reset';
  this.nestedKeys.forEach(function (key) {
    proxy[key][method]();
  });
}

var validationMethods = {
  $touch: function $touch() {
    setDirtyRecursive.call(this, true);
  },
  $reset: function $reset() {
    setDirtyRecursive.call(this, false);
  },
  $flattenParams: function $flattenParams() {
    var proxy = this.proxy;
    var params = [];
    for (var key in this.$params) {
      if (this.isNested(key)) {
        var childParams = proxy[key].$flattenParams();
        for (var j = 0; j < childParams.length; j++) {
          childParams[j].path.unshift(key);
        }
        params = params.concat(childParams);
      } else {
        params.push({ path: [], name: key, params: this.$params[key] });
      }
    }
    return params;
  }
};

var getterNames = Object.keys(validationGetters);
var methodNames = Object.keys(validationMethods);

var _cachedComponent = null;
var getComponent = function getComponent(Vue) {
  if (_cachedComponent) {
    return _cachedComponent;
  }

  var VBase = Vue.extend({
    beforeCreate: function beforeCreate() {
      this._vval = null;
    },
    beforeDestroy: function beforeDestroy() {
      if (this._vval) {
        (0, _vval.patchChildren)(this._vval);
      }
    },

    methods: {
      getModel: function getModel() {
        return this.lazyModel ? this.lazyModel(this.prop) : this.model;
      },
      getModelKey: function getModelKey(key) {
        var model = this.getModel();
        if (model) {
          return model[key];
        }
      }
    },
    computed: {
      refs: function refs() {
        var oldVval = this._vval;
        this._vval = this.children;
        (0, _vval.patchChildren)(oldVval, this._vval);
        var refs = {};
        this._vval.forEach(function (c) {
          refs[c.key] = c.vm;
        });
        return refs;
      }
    }
  });

  var ValidationRule = VBase.extend({
    data: function data() {
      return {
        rule: null,
        lazyModel: null,
        model: null,
        lazyParentModel: null,
        rootModel: null
      };
    },

    methods: {
      runRule: function runRule(parent) {
        // Avoid using this.lazyParentModel to not get dependent on it.
        // Passed as an argument for workaround
        var model = this.getModel();
        (0, _params.pushParams)();
        var rawOutput = this.rule.call(this.rootModel, model, parent);
        var output = isPromise(rawOutput) ? makePendingAsyncVm(Vue, rawOutput) : rawOutput;

        var rawParams = (0, _params.popParams)();
        var params = rawParams && rawParams.$sub ? rawParams.$sub.length > 1 ? rawParams : rawParams.$sub[0] : null;

        return { output: output, params: params };
      }
    },
    computed: {
      run: function run() {
        return this.runRule(this.lazyParentModel());
      },
      $params: function $params() {
        return this.run.params;
      },
      proxy: function proxy() {
        var output = this.run.output;
        if (output[__isVuelidateAsyncVm]) {
          return !!output.v;
        }
        return !!output;
      },
      $pending: function $pending() {
        var output = this.run.output;
        if (output[__isVuelidateAsyncVm]) {
          return output.p;
        }
        return false;
      }
    }
  });

  var Validation = VBase.extend({
    data: function data() {
      return {
        dirty: false,
        validations: null,
        lazyModel: null,
        model: null,
        prop: null,
        lazyParentModel: null,
        rootModel: null
      };
    },

    methods: _extends({}, validationMethods, {
      refProxy: function refProxy(key) {
        return this.getRef(key).proxy;
      },
      getRef: function getRef(key) {
        return this.refs[key];
      },
      isNested: function isNested(key) {
        return typeof this.validations[key] !== 'function';
      }
    }),
    computed: _extends({}, validationGetters, {
      nestedKeys: function nestedKeys() {
        return this.keys.filter(this.isNested);
      },
      ruleKeys: function ruleKeys() {
        var _this5 = this;

        return this.keys.filter(function (k) {
          return !_this5.isNested(k);
        });
      },
      keys: function keys() {
        return Object.keys(this.validations).filter(function (k) {
          return k !== '$params';
        });
      },
      proxy: function proxy() {
        var _this6 = this;

        var keyDefs = buildFromKeys(this.keys, function (key) {
          return {
            enumerable: true,
            configurable: true, // allow mocking lib calls
            get: function get() {
              return _this6.refProxy(key);
            }
          };
        });

        var getterDefs = buildFromKeys(getterNames, function (key) {
          return {
            enumerable: true,
            configurable: true,
            get: function get() {
              return _this6[key];
            }
          };
        });

        var methodDefs = buildFromKeys(methodNames, function (key) {
          return {
            enumerable: false,
            configurable: true,
            get: function get() {
              return _this6[key];
            }
          };
        });

        return Object.defineProperties({}, _extends({}, keyDefs, getterDefs, methodDefs));
      },
      children: function children() {
        var _this7 = this;

        return [].concat(this.nestedKeys.map(function (key) {
          return renderNested(_this7, key);
        }), this.ruleKeys.map(function (key) {
          return renderRule(_this7, key);
        })).filter(Boolean);
      }
    })
  });

  var GroupValidation = Validation.extend({
    methods: {
      isNested: function isNested(key) {
        return typeof this.validations[key]() !== 'undefined';
      },
      getRef: function getRef(key) {
        var vm = this;
        return {
          get proxy() {
            // default to invalid
            return vm.validations[key]() || false;
          }
        };
      }
    }
  });

  var EachValidation = Validation.extend({
    computed: {
      keys: function keys() {
        var model = this.getModel();
        if (isObject(model)) {
          return Object.keys(model);
        } else {
          return [];
        }
      },
      tracker: function tracker() {
        var _this8 = this;

        var trackBy = this.validations.$trackBy;
        return trackBy ? function (key) {
          return '' + getPath(_this8.rootModel, _this8.getModelKey(key), trackBy);
        } : function (x) {
          return '' + x;
        };
      },
      eagerParentModel: function eagerParentModel() {
        var parent = this.lazyParentModel();
        return function () {
          return parent;
        };
      },
      children: function children() {
        var _this9 = this;

        var def = this.validations;
        var model = this.getModel();

        var validations = _extends({}, def);
        delete validations['$trackBy'];

        var usedTracks = {};

        return this.keys.map(function (key) {
          var track = _this9.tracker(key);
          if (usedTracks.hasOwnProperty(track)) {
            return null;
          }
          usedTracks[track] = true;
          return (0, _vval.h)(Validation, track, {
            validations: validations,
            prop: key,
            lazyParentModel: _this9.eagerParentModel,
            model: model[key],
            rootModel: _this9.rootModel
          });
        }).filter(Boolean);
      }
    },
    methods: {
      isNested: function isNested() {
        return true;
      },
      getRef: function getRef(key) {
        return this.refs[this.tracker(key)];
      }
    }
  });

  var renderNested = function renderNested(vm, key) {
    if (key === '$each') {
      return (0, _vval.h)(EachValidation, key, {
        validations: vm.validations[key],
        lazyParentModel: vm.lazyParentModel,
        prop: key,
        lazyModel: vm.getModel,
        rootModel: vm.rootModel
      });
    }
    var validations = vm.validations[key];
    if (Array.isArray(validations)) {
      var root = vm.rootModel;
      var refVals = buildFromKeys(validations, function (path) {
        return function () {
          return getPath(root, root.$v, path);
        };
      }, function (v) {
        return Array.isArray(v) ? v.join('.') : v;
      });
      return (0, _vval.h)(GroupValidation, key, {
        validations: refVals,
        lazyParentModel: NUL,
        prop: key,
        lazyModel: NUL,
        rootModel: root
      });
    }
    return (0, _vval.h)(Validation, key, {
      validations: validations,
      lazyParentModel: vm.getModel,
      prop: key,
      lazyModel: vm.getModelKey,
      rootModel: vm.rootModel
    });
  };

  var renderRule = function renderRule(vm, key) {
    return (0, _vval.h)(ValidationRule, key, {
      rule: vm.validations[key],
      lazyParentModel: vm.lazyParentModel,
      lazyModel: vm.getModel,
      rootModel: vm.rootModel
    });
  };

  _cachedComponent = { VBase: VBase, Validation: Validation };
  return _cachedComponent;
};

var _cachedVue = null;
function getVue(rootVm) {
  if (_cachedVue) return _cachedVue;
  var Vue = rootVm.constructor;
  /* istanbul ignore next */
  while (Vue.super) {
    Vue = Vue.super;
  }_cachedVue = Vue;
  return Vue;
}

var validateModel = function validateModel(model, validations) {
  var Vue = getVue(model);

  var _getComponent = getComponent(Vue),
      Validation = _getComponent.Validation,
      VBase = _getComponent.VBase;

  var root = new VBase({
    computed: {
      children: function children() {
        var vals = typeof validations === 'function' ? validations.call(model) : validations;

        return [(0, _vval.h)(Validation, '$v', {
          validations: vals,
          lazyParentModel: NUL,
          prop: '$v',
          model: model,
          rootModel: model
        })];
      }
    }
  });
  return root;
};

var validationMixin = {
  data: function data() {
    var vals = this.$options.validations;
    if (vals) {
      this._vuelidate = validateModel(this, vals);
    }
    return {};
  },
  beforeCreate: function beforeCreate() {
    var options = this.$options;
    var vals = options.validations;
    if (!vals) return;
    if (!options.computed) options.computed = {};
    if (options.computed.$v) return;
    options.computed.$v = function () {
      return this._vuelidate ? this._vuelidate.refs.$v.proxy : null;
    };
  },
  beforeDestroy: function beforeDestroy() {
    if (this._vuelidate) {
      this._vuelidate.$destroy();
      this._vuelidate = null;
    }
  }
};

function Vuelidate(Vue) {
  Vue.mixin(validationMixin);
}

exports.Vuelidate = Vuelidate;
exports.validationMixin = validationMixin;
exports.withParams = _params.withParams;
exports.default = Vuelidate;

/***/ }),

/***/ 946:
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.patchChildren = patchChildren;
exports.h = h;
// a minimial single-layer implementation
// of virtual-validation patching,
// based on Vue's snabbdom clone

function isUndef(v) {
  return v === null || v === undefined;
}

function isDef(v) {
  return v !== null && v !== undefined;
}

function sameVval(oldVval, vval) {
  return vval.tag === oldVval.tag && vval.key === oldVval.key;
}

function createVm(vval) {
  var Vm = vval.tag;
  vval.vm = new Vm({ data: vval.args });
}

function updateVval(vval) {
  var keys = Object.keys(vval.args);
  for (var i = 0; i < keys.length; i++) {
    keys.forEach(function (k) {
      vval.vm[k] = vval.args[k];
    });
  }
}

function createKeyToOldIdx(children, beginIdx, endIdx) {
  var i = void 0,
      key = void 0;
  var map = {};
  for (i = beginIdx; i <= endIdx; ++i) {
    key = children[i].key;
    if (isDef(key)) map[key] = i;
  }
  return map;
}

function updateChildren(oldCh, newCh) {
  var oldStartIdx = 0;
  var newStartIdx = 0;
  var oldEndIdx = oldCh.length - 1;
  var oldStartVval = oldCh[0];
  var oldEndVval = oldCh[oldEndIdx];
  var newEndIdx = newCh.length - 1;
  var newStartVval = newCh[0];
  var newEndVval = newCh[newEndIdx];
  var oldKeyToIdx = void 0,
      idxInOld = void 0,
      elmToMove = void 0;

  while (oldStartIdx <= oldEndIdx && newStartIdx <= newEndIdx) {
    if (isUndef(oldStartVval)) {
      oldStartVval = oldCh[++oldStartIdx]; // Vval has been moved left
    } else if (isUndef(oldEndVval)) {
      oldEndVval = oldCh[--oldEndIdx];
    } else if (sameVval(oldStartVval, newStartVval)) {
      patchVval(oldStartVval, newStartVval);
      oldStartVval = oldCh[++oldStartIdx];
      newStartVval = newCh[++newStartIdx];
    } else if (sameVval(oldEndVval, newEndVval)) {
      patchVval(oldEndVval, newEndVval);
      oldEndVval = oldCh[--oldEndIdx];
      newEndVval = newCh[--newEndIdx];
    } else if (sameVval(oldStartVval, newEndVval)) {
      // Vval moved right
      patchVval(oldStartVval, newEndVval);
      oldStartVval = oldCh[++oldStartIdx];
      newEndVval = newCh[--newEndIdx];
    } else if (sameVval(oldEndVval, newStartVval)) {
      // Vval moved left
      patchVval(oldEndVval, newStartVval);
      oldEndVval = oldCh[--oldEndIdx];
      newStartVval = newCh[++newStartIdx];
    } else {
      if (isUndef(oldKeyToIdx)) oldKeyToIdx = createKeyToOldIdx(oldCh, oldStartIdx, oldEndIdx);
      idxInOld = isDef(newStartVval.key) ? oldKeyToIdx[newStartVval.key] : null;
      if (isUndef(idxInOld)) {
        // New element
        createVm(newStartVval);
        newStartVval = newCh[++newStartIdx];
      } else {
        elmToMove = oldCh[idxInOld];
        if (sameVval(elmToMove, newStartVval)) {
          patchVval(elmToMove, newStartVval);
          oldCh[idxInOld] = undefined;
          newStartVval = newCh[++newStartIdx];
        } else {
          // same key but different element. treat as new element
          createVm(newStartVval);
          newStartVval = newCh[++newStartIdx];
        }
      }
    }
  }
  if (oldStartIdx > oldEndIdx) {
    addVvals(newCh, newStartIdx, newEndIdx);
  } else if (newStartIdx > newEndIdx) {
    removeVvals(oldCh, oldStartIdx, oldEndIdx);
  }
}

function addVvals(vvals, startIdx, endIdx) {
  for (; startIdx <= endIdx; ++startIdx) {
    createVm(vvals[startIdx]);
  }
}

function removeVvals(vvals, startIdx, endIdx) {
  for (; startIdx <= endIdx; ++startIdx) {
    var ch = vvals[startIdx];
    if (isDef(ch)) {
      ch.vm.$destroy();
      ch.vm = null;
    }
  }
}

function patchVval(oldVval, vval) {
  if (oldVval === vval) {
    return;
  }
  vval.vm = oldVval.vm;
  updateVval(vval);
}

function patchChildren(oldCh, ch) {
  if (isDef(oldCh) && isDef(ch)) {
    if (oldCh !== ch) updateChildren(oldCh, ch);
  } else if (isDef(ch)) {
    addVvals(ch, 0, ch.length - 1);
  } else if (isDef(oldCh)) {
    removeVvals(oldCh, 0, oldCh.length - 1);
  }
}

function h(tag, key, args) {
  return { tag: tag, key: key, args: args };
}

/***/ })

});


// WEBPACK FOOTER //
// static/js/62.ae8d34dd.js